export default __webpack_public_path__ + "static/blueprint-5-13136ba74ec4d97d4d916bf097763a28.png";